import { combineReducers } from "redux";
import Form from "./Form";
import Response from "./Response";

const allReducers = combineReducers({
  form: Form,
  response: Response,
});

export default allReducers;
